import { createRequestFactory } from "@/lib/request-factory";
import {
  DeletePackageDocument,
  type DeletePackageMutation,
  type DeletePackageMutationVariables,
} from "@/__generated__/graphql";

export const useDeletePackageStore = createRequestFactory<
  DeletePackageMutation,
  DeletePackageMutation,
  DeletePackageMutationVariables
>({
  method: "mutation",
  graphqlDocument: DeletePackageDocument,
});
